import { useEffect, useRef, useState, type RefObject } from 'react';
import { focusFirstFieldError } from './focus-first-field-error.ts';

export interface FieldErrorFocus {
  formRef: RefObject<HTMLFormElement | null>;
  /** After a refused submit: the caret goes to the first field marked red once it renders. */
  focusFirstError: () => void;
}

/**
 * Puts the caret on the form's first field error, both when the form's own
 * checks refuse a submit and when a new set of errors comes from the server.
 */
export function useFieldErrorFocus(serverErrors: object): FieldErrorFocus {
  const formRef = useRef<HTMLFormElement>(null);
  const [focusRequest, setFocusRequest] = useState(0);

  useEffect(() => {
    if (focusRequest > 0 && formRef.current) focusFirstFieldError(formRef.current);
  }, [focusRequest]);

  useEffect(() => {
    if (Object.keys(serverErrors).length > 0 && formRef.current) {
      focusFirstFieldError(formRef.current);
    }
  }, [serverErrors]);

  return { formRef, focusFirstError: () => setFocusRequest((count) => count + 1) };
}
